var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4366 13.2523C13.741 13.5729 13.7233 14.0754 13.3972 14.3747L10.8568 16.7059H14.1923C14.524 16.7059 14.8221 16.9053 14.9437 17.2088C15.0654 17.5122 14.9859 17.858 14.7434 18.0805L10.705 21.7864C10.3789 22.0857 9.86776 22.0683 9.5634 21.7477C9.25903 21.4271 9.27666 20.9246 9.60276 20.6253L12.1432 18.2941H8.80772C8.47596 18.2941 8.17795 18.0947 8.0563 17.7912C7.93464 17.4878 8.01409 17.142 8.25662 16.9195L12.295 13.2136C12.6211 12.9143 13.1322 12.9317 13.4366 13.2523Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74221 16.4767C6.865 16.2317 7.03288 16.0065 7.24235 15.8143L11.2808 12.1084C12.2088 11.2568 13.6554 11.3041 14.5244 12.2196C15.3324 13.0707 15.3562 14.3706 14.6316 15.2479C15.3858 15.3934 16.0383 15.9083 16.3359 16.6506C16.3819 16.7654 16.4181 16.8823 16.4446 17H18C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C17.6514 9 17.3133 9.04459 16.991 9.12836C16.7973 5.15887 13.5175 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 12.6684 3.96467 15.3779 6.74221 16.4767Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderAlt);
export default __webpack_public_path__ + "static/media/thunder-alt.b8abe702169e28904e82e17a76f0c1bc.svg";
export { ForwardRef as ReactComponent };